import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';
import mainImg from '~/static/images/domofon/meeting/main.svg';
import mainMediumImg from '~/static/images/domofon/meeting/main-medium.svg';
import mainSmallImg from '~/static/images/domofon/meeting/main-small.svg';
import mainBigImg from '~/static/images/domofon/meeting/main-big.svg';
import mainMobileImg from '~/static/images/domofon/meeting/main-mobile.svg';

export const Wrapper = styled.div`
    display: block;
    width: 100%;
    @media screen and (max-width: 1700px){
        padding-bottom: 360px;
    }
`;

export const Head = styled.div`
    display: flex;
    background: url(${mainImg}), linear-gradient(38.61deg, #B5C1E7 6.47%, #FEF2F2 139.94%);
    background-position: right bottom;
    background-repeat: no-repeat;
    height: 620px;  
    @media screen and (max-width: 1700px){
        background: url(${mainMediumImg}), linear-gradient(38.61deg, #B5C1E7 6.47%, #FEF2F2 139.94%);
        background-position: right bottom;
        background-repeat: no-repeat;
    }
    @media screen and (max-width: 1200px){
        background: url(${mainSmallImg}), linear-gradient(38.61deg, #B5C1E7 6.47%, #FEF2F2 139.94%);
        background-position: right bottom;
        background-repeat: no-repeat;
    }
    @media screen and (max-width: 990px){
        background: url(${mainBigImg}), linear-gradient(38.61deg, #B5C1E7 6.47%, #FEF2F2 139.94%);
        background-position: right bottom;
        background-repeat: no-repeat;
        height: 935px; 
    }
    @media screen and (max-width: 560px){
        background: url(${mainMobileImg}), linear-gradient(38.61deg, #B5C1E7 6.47%, #FEF2F2 139.94%);
        background-position: right bottom;
        background-repeat: no-repeat;
        height: 710px; 
        width: auto;
    }
`;

export const HeadConten = styled.div`
    display: flex;
    flex-direction: column;
    margin: 232px 0 233px 216px;
    width: 548px;
    height: auto;
    @media screen and (max-width: 1700px){
        margin: 232px 0 233px 103px;
    }
    @media screen and (max-width: 1200px){
        margin: 232px 0 233px 48px;
    }
    @media screen and (max-width: 990px){
        margin: 100px 0 0 34px;
    }
    @media screen and (max-width: 560px){
        margin: 140px 0 0 17px;
        width: 287px;
    }
`;
export const HeadTitle = styled.h1`
    display: flex;
    margin-bottom: 15px;
    ${FONTS.H1};
    @media screen and (max-width: 1200px){
        ${FONTS.H2};
    }
    @media screen and (max-width: 990px){
        ${FONTS.H1};
    }
    @media screen and (max-width: 560px){
        ${FONTS.H2};
    }
`;
export const HeadText = styled.div`
    display: flex;
    ${FONTS.L};
    @media screen and (max-width: 1200px){
        width: 487px;
    }
    @media screen and (max-width: 1024px){
        width: 444px;
    }
    @media screen and (max-width: 560px){
        ${FONTS.S};
        width: 269px;
    }
`;

export const Advanteges = styled.div`
    display: flex;
    height: auto; 
    background-color: ${COLORS.white};
`;

export const AdvantegesContent = styled.div`
    display: flex;
    flex-direction: column;
    margin: 106px 0 112px 216px;
    @media screen and (max-width: 1700px){
        margin: 106px 0 112px 105px;
    }
    @media screen and (max-width: 1200px){
        margin: 106px 0 112px 48px;
    }
    @media screen and (max-width: 990px){
        margin: 106px 0 112px 34px;
    }
    @media screen and (max-width: 560px){
        margin: 63px 16px;
    }
`;

export const AdvantegesTitle = styled.div`
    display: flex;
    ${FONTS.H2};
    @media screen and (max-width: 560px){
        ${FONTS.H3};
    }
`;

export const Steps = styled.div`
    display: flex;
    height: auto; 
    background-color: ${COLORS.lightGrey}; 
`;
